import React from 'react';
import renderHTML from 'react-render-html';


import Logo from 'components/logo/logo.component';

// Styles
import {
  StyledFooterWrapper,
  StyledColumnLeft,
  StyledColumnRight,
  StyledLogoWrapper,
  StyledCopyright,
  StyledContactInfo,
  StyledAuthor
} from "./footer.style";

import { StyledElementWrapperCenter } from "styledElements";

// Texts
import text from 'i18l';

// Icons
import IconPhone from 'icons/phone.icon';
import IconMail from 'icons/mail.icon';
import IconAddress from 'icons/address.icon';
import IconHeart from 'icons/heart.icon';


const Footer = () => (
  <StyledFooterWrapper>
    <StyledElementWrapperCenter>
      <StyledColumnLeft>
        <StyledLogoWrapper>
          <Logo />
        </StyledLogoWrapper>
        <StyledCopyright>
          {renderHTML(text.FOOTER.COPYRIGHT)}
        </StyledCopyright>
      </StyledColumnLeft>
      <StyledColumnRight>
        <div itemscope itemtype="https://schema.org/LocalBusiness">
          <StyledContactInfo>
            <IconMail/>
            <span itemProp="email">{renderHTML(text.FOOTER.MAIL)}</span>
          </StyledContactInfo>
          <StyledContactInfo>
            <IconPhone/>
            <span itemProp="telephone">{renderHTML(text.FOOTER.PHONE)}</span>
          </StyledContactInfo>
          <StyledContactInfo>
            <IconAddress/>
            <span itemprop="address">{renderHTML(text.FOOTER.ADDRESS)}</span>
          </StyledContactInfo>
          <StyledAuthor>
            Create with <IconHeart/> to code by <a href="http://dev-industry.com" target="_blank" rel="noopener noreferrer" >DEV INDUSTRY</a>
          </StyledAuthor>
        </div>
      </StyledColumnRight>
    </StyledElementWrapperCenter>
  </StyledFooterWrapper>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.component.js